import { createFuseSearch } from '@/experiences/sales-portal/blocs/utils/fuzzy-search';
import { OrderEntryTableRowData } from '@/experiences/sales-portal/domain/ordering/screens/order-entry/blocs/transformers/order-entry-table-transformers';

export const filterAndRankOrderEntryRows =
  createFuseSearch<OrderEntryTableRowData>({
    keys: [
      { name: 'name', weight: 2 },
      { name: 'externalItemId', weight: 1 },
      { name: 'brand', weight: 1 },
    ],
  });
